import React, { useState } from 'react';
import { Form, Button, Panel, Stack, Divider, Schema, FormInstance } from 'rsuite';
import Brand from '@/components/Brand';
import { LoginRequest, LoginResponse } from '@/models/user.model';
import { login } from '@/services/auth.service';
import { AxiosError } from 'axios';
import { BaseErrorModel, BaseResponseModel } from '@/models/core.model';
import AppContext from '@/infra/AppContext';
import { useNavigate } from 'react-router-dom';
import ErrorMessage from '@/components/ErrorMessage';
import { setStoredJwt } from '@/infra/http';

const modelSchema = Schema.Model<LoginRequest>({
  username: Schema.Types.StringType().isRequired('This field is required.'),
  password: Schema.Types.StringType().isRequired('Password is required')
});

const model: LoginRequest = {
  username: '',
  password: ''
};

const SignIn = () => {
  const [formValue, setFormValue] = useState(model);
  const [formError, setFormError] = useState({});
  const [errorModel, setErrorModel] = useState<BaseErrorModel|undefined>(undefined);
  const [loading, setLoading] = useState(false);

  const formRef = React.useRef<FormInstance<Record<string, any>>>(null);
  const { setUserData } = React.useContext(AppContext);
  const nav = useNavigate();

  const handleSubmit = async () => {
    if (formRef.current && !formRef.current.check()) {
      return;
    }
    setErrorModel(undefined);
    setLoading(true);
    try {
      const result: BaseResponseModel<LoginResponse> = await login(formValue);
      if (!result.success) {
        setErrorModel(result);
        return;
      }
      setStoredJwt(result.result.token);
      setUserData(result.result);
      nav("/dashboard");
    } catch (err) {
      setErrorModel((err as AxiosError<BaseErrorModel>).response?.data );
    }
    finally {
      setLoading(false);
    }
  };

  const handleFormChange = (value: Record<string, any>) => {
    setFormValue(prevFormValue => ({
      ...prevFormValue, 
      ...value 
    }));
  };

  return (
    <Stack
      justifyContent="center"
      alignItems="center"
      direction="column"
      style={{
        height: '100vh'
      }}
    >
      <Brand showtitle="true" style={{ marginBottom: 10 }} />

      <Panel bordered style={{ background: '#fff', width: 400 }} header="Sign In">
        <Form fluid ref={formRef}
          onChange={handleFormChange}
          onCheck={setFormError}
          formValue={formValue}
          model={modelSchema}>
          <Form.Group>
            <Form.Label>Username</Form.Label>
            <Form.Control name="username" />
          </Form.Group>
          <Form.Group>
            <Form.Label>
              <span>Password</span>
            </Form.Label>
            <Form.Control name="password" type="password" />
          </Form.Group>
          {errorModel && <ErrorMessage model={errorModel} style={{ marginTop: 20, marginBottom:20 }}></ErrorMessage>}
          <Form.Group>
            <Stack spacing={6} divider={<Divider vertical />}>
              <Button appearance="primary" type='submit' loading={loading} onClick={handleSubmit}>Sign in</Button>
            </Stack>
          </Form.Group>
        </Form>
      </Panel>

    </Stack>
  );
};

export default SignIn;
